import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import checkIcon from "../../assets/img/startTest/checkIcon.svg";
import queCount from "../../assets/img/startTest/queCount.svg";
import timeIcon from "../../assets/img/startTest/timeIcon.svg";
import placeholderIcon from "../../assets/icon/placeholderIcon.png";
import moment from "moment";
import "./card.scss";

import { getLocalStorage } from "../../helper/localStorage";
import { Tooltip } from "antd";
import defaultImage from "../../assets/img/startTest/cardImg/ic_190425225011.svg";

export default function Card({ testData, onClick }) {
  const completeTime = testData.complete_date.split(" ");
  const blankTime = completeTime[0] === "0000-00-00";

  const timeMs = testData.total_time * 1000;

  const time = moment.utc(timeMs).format("mm:ss");

  const showResult = getLocalStorage("show_result");

  const getBorder = () => {
    const backColor = testData.group_color.toUpperCase();
    let color;
    color =
      backColor === "#FFDDDD"
        ? "#F65858"
        : backColor === "#E9EDFE"
        ? "#223ED6"
        : backColor === "#F3DFFC"
        ? "#C951FF"
        : backColor === "#FFF1CD"
        ? "#FFCD4D"
        : backColor === "#E8FDEA"
        ? "#29E23A"
        : "#00000000";
    return color;
  };

  const getScoreClr = () => {
    const scoreColor =
      testData.score_rate === "STRONG"
        ? "#669933"
        : testData.score_rate === "NORMAL"
        ? "#EF7D33"
        : testData.score_rate === "WEEK"
        ? "#EE3042"
        : "#EE3042";

    return scoreColor;
  };


  const imgExists = (id) => {
    try {
      require(`../../assets/img/startTest/cardImg/ic_${id}.svg`);
      return true;
    } catch (error) {
      return false;
    }
  };

  const getImageSource = (id) => {
    if (id && imgExists(id)) {
      return require(`../../assets/img/startTest/cardImg/ic_${id}.svg`);
    } else {
      return defaultImage;
    }
  };
  return (
    <Tooltip title={testData.intro3}>
      <div
        className="card"
        style={{
          background: testData.group_color,
          borderBottom: `6px solid  ${getBorder()}`,
        }}
        onClick={onClick}
      >
        <div className="card-img">
          <LazyLoadImage
            alt=""
            // src={
            //   require(`../../assets/img/startTest/cardImg/ic_${testData.test_id}.svg`)
            //     .default
            // }
            src={
              getImageSource(testData.test_id)
              // ic_190425225011
            }
          />
        </div>
        <div className="card-brief">
          <h3>{testData.test_name}</h3>
          <div className="card-stats">
            <div className="card-que-count">
              <img src={queCount} alt="" className="" />
              <h3 className="">{testData.que_count}</h3>
            </div>
            <div className="card-time">
              <img src={timeIcon} alt="" className="" />
              <h3 className="">{time}</h3>
            </div>
          </div>
        </div>
        <div
          className="card__Status"
          style={{
            visibility: blankTime ? "hidden" : "visible",
            borderLeft: `2px solid ${getBorder()}`,
          }}
        >
          <div className="check_icon">
            <img src={checkIcon} alt="" className="" />
          </div>

          {/* <div
          className="test-score-block"
          style={{
            background: getScoreClr(),
          }}
        >
          <span className="test-score">{testData.score}</span>
        </div> */}

          {showResult === "Y" && (
            <div
              className="test-score-block"
              style={{
                background: getScoreClr(),
              }}
            >
              <span className="test-score">{testData.score}</span>
            </div>
          )}

          <span className="test-completion-time">
            {moment(completeTime[0]).format("DD MMM YY")}
          </span>
        </div>
      </div>
    </Tooltip>
  );
}
